'use strict';

import { validateField, removeValidationMessageElement } from 'app_vodafone_ziggo/util/validation';

/**
 * Dispatches an 'input' event on the given element.
 * @param {HTMLElement} element - The element to dispatch the event on.
 */
function dispatchInputEvent(element) {
    const event = new Event('input', { bubbles: true, cancelable: true });
    element.dispatchEvent(event);
}

/**
 * Clears all the fields in the provided form elements object and resets the validation.
 *
 * @param {Object} formElements - The form elements to be cleared.
 */
function clearFormFields(formElements) {
    Object.keys(formElements).forEach((key) => {
        const element = formElements[key];
        // Preselect the only option from a select element
        if (element.tagName === 'SELECT') {
            const notDisabledOptions = Array.from(element.options).filter((option) => !option.disabled);
            if (notDisabledOptions.length === 1) {
                element.selectedIndex = notDisabledOptions[0].index;
            }
        } else {
            element.value = '';
            formElements[key].classList.add('empty');
            validateField(formElements[key]);
        }

        dispatchInputEvent(element);
        element.classList.remove('invalid');
        removeValidationMessageElement(element);
    });
}

/**
 * Prefills the form fields with provided data.
 *
 * @param {Object} formElements - The form elements to be prefilled.
 * @param {Object} data - The data used to prefill the form elements.
 */
function prefillFormFields(formElements, data) {
    Object.keys(formElements).forEach((key) => {
        const element = formElements[key];
        element.value = data[key] || '';

        if (element.value) {
            element.classList.remove('empty');
        }

        dispatchInputEvent(element);
    });
}

/**
 * Sets the required attribute on specified contact form fields.
 *
 * @param {Object} formElements - An object containing the form elements to be modified.
 * @param {boolean} isRequired - A boolean indicating whether the fields should be marked as required.
 */
function makeContactFormFieldsRequired(formElements, isRequired) {
    [formElements.initials, formElements.lastName, formElements.email, formElements.phone].forEach((input) => {
        input.required = isRequired;
        input.setAttribute('aria-required', isRequired.toString());
    });
}

export { clearFormFields, prefillFormFields, makeContactFormFieldsRequired };
